// extracted by mini-css-extract-plugin
export default {"mainCard":"MainCard_mainCard__fhQ66","inputBirthdate":"MainCard_inputBirthdate__oETuJ"};